import toast from 'react-hot-toast';
import StyledImage from '@apps/components/Image';
import { useAmp } from 'next/amp';
import Link from 'next/link';

export type SocialIconButtonProps = React.PropsWithChildren<{
  icon?: string;
  href?: string;
  onClick?: () => void;
  buttonStyle?: React.CSSProperties;
  isSvg?: boolean;
  ampType?: string;
}>;

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const SocialIconButton: React.FC<SocialIconButtonProps> = (props) => {
  const {
    icon,
    href = '/',
    onClick,
    buttonStyle,
    isSvg = false,
    ampType,
    children,
  } = props;
  const isAmp = useAmp();

  // ======================= VIEWS
  if (isAmp && ampType) {
    if (ampType === 'facebook' || ampType === 'copy') return;
    return (
      <amp-social-share
        type={ampType as string}
        width="23px"
        height="23px"
        data-param-url={href}
      />
    );
  }

  if (isSvg) {
    return (
      <Link
        href={href}
        target="_blank"
        style={{
          cursor: 'pointer',
        }}
        onClick={(e) => {
          if (onClick) {
            e.preventDefault();
            // window.open(href, '_blank');
            onClick?.();
          }
        }}
      >
        {children}
      </Link>
    );
  }
  if (!icon) return null;
  return (
    <Link
      href={href}
      target="_blank"
      style={{
        cursor: 'pointer',
      }}
      onClick={(e) => {
        if (onClick) {
          e.preventDefault();
          // window.open(href, '_blank');
          onClick?.();
        }
      }}
    >
      <div
        style={{
          width: 24,
          height: 24,
          ...buttonStyle,
        }}
        onClick={() => {
          toast.error('123');
        }}
      >
        <StyledImage src={icon} alt="" width={24} height={24} />
      </div>
    </Link>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default SocialIconButton;
